import { useUpdate } from '@lib/systems/update'
import { useState } from '@lib/systems/state'
import { useWind } from '@game/systems/wind'

const state = useState()
const { direction: wind } = useWind()

class Animations {
  constructor () {
    this.actors = {}
  }

  clear () {
    for (const key in this.actors) {
      delete this.actors[key]
    }
  }

  update (numPoms) {
    let actor, dx, dy, found
    for (let i = 0; i < numPoms; i++) {
      if (!this.actors[i]) {
        this.actors[i] = {
          x: 0,
          y: 0,
          velx: 0,
          vely: 0,
          tarx: 0,
          tary: 0,
          scale: 0,
          tarscale: 1,
          speed: 0.05,
          selectRadius: 0,
          selectPom: null
        }
      }
      actor = this.actors[i]

      // Wind
      dx = wind.x
      dy = wind.y
      actor.velx += dx
      actor.vely += dy

      // Position
      dx = (actor.tarx - actor.x) * actor.speed
      dy = (actor.tary - actor.y) * actor.speed
      actor.velx += dx
      actor.vely += dy
      actor.x += actor.velx
      actor.y += actor.vely
      actor.velx *= 0.875
      actor.vely *= 0.875

      // Scale
      dx = (actor.tarscale - actor.scale) * actor.speed
      actor.scale += dx

      // Selection UI
      found = -1
      if (state.board.canJumpTo) {
        for (let k = 0; k < state.board.canJumpTo.length && found <= 0; k++) {
          if (state.board.canJumpTo[k] === i) {
            found = 2
            actor.selectPom = state.board.canJumpTo[k]
          }
        }
      }
      if (state.board.canSplitTo) {
        for (let k = 0; k < state.board.canSplitTo.length && found <= 0; k++) {
          if (state.board.canSplitTo[k] === i) {
            found = 6
            actor.selectPom = state.board.canSplitTo[k]
          }
        }
      }
      dx = (found - actor.selectRadius) * (actor.speed * 4)
      actor.selectRadius += dx

      if (actor.selectRadius < 0.5) {
        actor.selectPom = null
      }
    }
  }

  jiggle (i, amt) {
    if (!this.actors[i]) return
    this.actors[i].velx += (Math.random() > 0.5) ? (amt * -1) : amt
    this.actors[i].vely += (Math.random() > 0.5) ? (amt * -1) : amt
  }

  clearSelection () {
    Object.keys(this.actors).forEach((i) => {
      this.actors[i].selectPom = null
      this.actors[i].selectRadius = 0
    })
  }
}

const animations = new Animations()

export function enableAnimations () {
  useUpdate(function () {
    animations.update(state.board.poms.length)
  }, {
    updateOrder: -1
  })
}

export function useAnimations () {
  return {
    clear: animations.clear.bind(animations),
    actors: animations.actors,
    jiggle: animations.jiggle.bind(animations),
    clearSelection: animations.clearSelection.bind(animations)
  }
}
